<template>
  <div class="pool">
    <div class="pool-top">
      <span class="pool-title">{{$bus.transify['FLIP_CARD_POOL']}}</span>
    </div>
    <ul class="pool-content">
      <template v-for="(item, index) in $bus.rewardPool">
        <Item role="li" @click.native.stop="showName(index)"
          class="pool-item"
          :key="item.id"
          :type="item.type === 1 ? 'light' : 'normal'"
          :nums="item.num"
          :imgSrc="item.src"
          :status="item.status">
          <div class="pool-item-name" @click.stop v-show="index === showNameIdx">
            <span>{{item.name}}</span>
          </div>
        </Item>
      </template>
    </ul>
    <div class="pool-refresh">
      <ff-button type="refresh" :active="$bus.actInfo.canRefresh" :light="!poolStatus && $bus.actInfo.canRefresh" @btnEvent="handleRefresh">
        <div class="refresh-info">
          <i class="refresh-icon" v-show="$bus.actInfo.canRefresh"></i>
          <div class="refresh-text">
            <span class="refresh-tip" :class="!$bus.actInfo.canRefresh ? 'done' : ''">{{ $bus.actInfo.canRefresh ? $bus.transify['FLIP_REFRESH'] : $bus.transify['FLIP_REFRESH_DONE']}}</span>
            <div class="refresh-cost" v-if="$bus.actInfo.canRefresh">
              <i class="diamond"></i>
              <span class="cost-nums" :class="payRefresh ? '': 'free-text'">{{payRefresh ? $bus.actInfo.refreshCost : $bus.transify['FLIP_FREE']}}</span>
            </div>
          </div>
        </div>
      </ff-button>
      <div class="refresh-times">
        {{ refreshTimes }}
      </div>
    </div>
  </div>
</template>

<script>
import Item from '@/components/common/Item.vue'
import ffButton from '@/components/common/Button.vue'
export default {
  components: {
    Item,
    ffButton
  },
  data () {
    return {
      showNameIdx: null,
      timer: null
    }
  },
  computed: {
    poolStatus () {
      for (let item of this.$bus.rewardPool) {
        if (item.status === 1) {
          return false
        }
      }
      return true
    },
    refreshStatus () {
      let [ useFreeRefresh, allRefresh ] = [
        this.$bus.actInfo.useFreeRefresh,
        this.$bus.actInfo.allRefresh
      ]
      return useCostRefresh + useFreeRefresh < allRefresh
    },
    payRefresh () {
      if (this.$bus.actInfo.useFreeRefresh >= this.$bus.actInfo.allFreeRefresh) {
        return true // pay
      } else {
        return false // free
      }
    },
    refreshTimes () {
      let [ useFreeRefresh, allFreeRefresh ] = [
        this.$bus.actInfo.useFreeRefresh,
        this.$bus.actInfo.allFreeRefresh
      ]
      return this.payRefresh ? '' : `${allFreeRefresh - useFreeRefresh} / ${allFreeRefresh}`
    }
  },
  methods: {
    showName (idx) {
      clearTimeout(this.timer)
      if (this.showNameIdx === idx) {
        this.showNameIdx = null
        return false
      }
      this.showNameIdx = idx
      this.timer = setTimeout(() => {
        this.showNameIdx = null
      }, 3000)
    },
    handleRefresh () {
      let refreshCost = this.$bus.actInfo.refreshCost
      if (this.$bus.shuffleAnime || this.$bus.flipAnime) return
      if (!this.$bus.actInfo.canRefresh) {
        this.$bus.handleToast(true, 'FLIP_REFRESH_ALL_POOL')
        return false
      }
      if (!this.payRefresh) {
        this.$bus.refresh(0)
      } else if (this.$bus.gems >= refreshCost) {
        this.$bus.refreshNotice ? this.$bus.confirmDialog = {
          show: true,
          type: 'refresh'
        } : this.$bus.refresh(refreshCost)
      } else {
        this.$bus.handleToast(true, 'FLIP_GEM_NOT_ENOUGH')
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      document.addEventListener('click', () => {
        clearTimeout(this.timer)
        this.showNameIdx = null
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.pool {
  @include px2res(width, 274);
  @include px2res(height, 689);
}
.pool-top {
  @include px2res(width, 252);
  @include px2res(height, 98);
  @include flexrc;
  align-items: flex-start;
  text-align: center;
}
.pool-title {
  flex: auto;
  width: 100%;
  text-transform: uppercase;
  line-height: 1;
  font-style: italic;
  font-weight: 500;
  color:rgba(234,201,70,1);
  @include px2res(margin-top, 24);
  @include px2res(font-size, 44);
  @include text-gradient(#d79807 10%, #fbf47e 90%);
}
.pool-content {
  @include px2res(width, 252);
  @include px2res(padding, 0, 0, 22);
}
.pool-item {
  @include px2res(margin, 22, auto, 0);
  position: relative;
}
.pool-item-name {
  position: absolute;
  top: 50%;
  left: 106%;
  z-index: 99;
  transform: translate(0, -50%);
  @include px2res(padding, 5, 20);
  @include px2res(font-size, 20);
  @include px2res(min-width, 100);
  letter-spacing: .5px;
  white-space: nowrap;;
  border: 1px solid #deaa44;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
  line-height: 1;
  background-color: #080707;
  text-align: center;
  animation: nameIn .3s ease-out both;
}
.pool-refresh {
  @include flexcc;
  @include px2res(width, 252);
}
.refresh-info {
  @include flexrc;
  font-style: italic;
  font-weight: 500;
  color: #000;
  line-height: 1;
}
.refresh-icon {
  @include px2res(width, 53);
  @include px2res(height, 48);
}
.refresh-text {
  @include flexcc;
  @include px2res(padding, 0, 20, 0, 8);
}
.refresh-btn.dark .refresh-text {
  padding: 0;
}
.refresh-tip {
  @include px2res(height, 30);
  text-shadow: 3px 0 2px rgba(247, 205, 25, .8), -2px 0 2px rgba(247, 205, 25, .8);
}
.refresh-tip.done {
  height: auto;
}
.refresh-cost {
  @include flexrc;
  @include px2res(font-size, 30);
  .diamond {
    @include px2res(width, 30);
    @include px2res(height, 27);
  }
  .cost-nums {
    @include px2res(height, 27);
    @include px2res(margin-left, 2);
  }
  .cost-nums.free-text {
    @include px2res(font-size, 24);
    @include px2res(height, 24);
  }
}
.refresh-times {
  @include px2res(font-size, 30);
  font-style: italic;
  font-weight: 500;
}
@keyframes nameIn {
  0% {
    opacity: 0;
    top: 60%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pool/index.vue